import i18n from "@/i18n";

import { CustomFilter } from "@/types/custom-filter";

import { FalconDocumentsPaymentType } from "@/enums/falcon/documents/falcon-documents-payment-type.enum";
import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon documents payment type filter
 */
export const falconDocumentsPaymentTypeFilter: CustomFilter = {
  falconDocumentsPaymentType(value: any): string {
    value = +value as FalconDocumentsPaymentType;
    if (value === FalconDocumentsPaymentType.None) {
      value = i18n.t(I18nMessageKey.SharedFiltersDocumentsPaymentTypeNoneText);
    } else if (value === FalconDocumentsPaymentType.Cash) {
      value = i18n.t(I18nMessageKey.SharedFiltersDocumentsPaymentTypeCashText);
    } else if (value === FalconDocumentsPaymentType.TerminalCash) {
      value = i18n.t(
        I18nMessageKey.SharedFiltersDocumentsPaymentTypeTerminalCashText
      );
    } else if (value === FalconDocumentsPaymentType.Check) {
      value = i18n.t(I18nMessageKey.SharedFiltersDocumentsPaymentTypeCheckText);
    } else if (value === FalconDocumentsPaymentType.Transfer) {
      value = i18n.t(
        I18nMessageKey.SharedFiltersDocumentsPaymentTypeTransferText
      );
    } else if (value === FalconDocumentsPaymentType.CashAndTransfer) {
      value = i18n.t(
        I18nMessageKey.SharedFiltersDocumentsPaymentTypeCashAndTransferText
      );
    } else if (value === FalconDocumentsPaymentType.CashOnDelivery) {
      value = i18n.t(
        I18nMessageKey.SharedFiltersDocumentsPaymentTypeCashOnDeliveryText
      );
    } else if (value === FalconDocumentsPaymentType.CreditCard) {
      value = i18n.t(
        I18nMessageKey.SharedFiltersDocumentsPaymentTypeCreditCardText
      );
    } else if (value === FalconDocumentsPaymentType.Installments) {
      value = i18n.t(
        I18nMessageKey.SharedFiltersDocumentsPaymentTypeInstallmentsText
      );
    } else {
      value = "";
    }
    return value;
  }
};
